
import { useFetchTournamentsQuery } from "../../store/tournament/TournamentApi";
import { useGetProfileQuery } from "../../store/auth/AuthApi";
import { useFetchClubsRegistrationsQuery } from "../../store/club/ClubApi";

import { useParams, useNavigate } from "react-router";
import { FormControl, Box, Divider } from "@mui/material";
import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { IconButton, Menu, MenuItem, List, ListItemButton, ListItemText } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LinearProgress from '@mui/material/LinearProgress';
import { myConstants } from "../Constants";
import InboxIcon from '@mui/icons-material/Inbox';

function TournamentName(tournament)
{
  if (!tournament)
  {
    return null;
  }

  let tournamentName = tournament?.counter + '. ' + tournament?.name + ' vom ' 
    + (new Date(tournament.dateFrom)).toLocaleDateString('de-DE') 
    + ' bis ' + (new Date(tournament.dateUpto)).toLocaleDateString('de-DE');

  if (tournament.closed)
  {
    return (<>{tournamentName}<LockOutlinedIcon /></>);
  }
  else
  {
    return (<>{tournamentName}</>);
  }
};



export function Title()
{
  
  const {data:user, isLoading:userIsLoading, isUninitialized:userIsUninitialized} = useGetProfileQuery();
  const {data:tournaments, isLoading:tournamentIsLoading, isUninitialized:tournamentIsUninitialized} = useFetchTournamentsQuery();
  
  const params = useParams();
  const yearSelector = parseInt(params.year);
  const clubLabel    = params.clubLabel;
  const navigate = useNavigate();
  
  const { data:registrations } = useFetchClubsRegistrationsQuery(yearSelector, { skip: !yearSelector });

  // Ermitteln der registrierten Clubs - diese sollen im Bread-Crumb-Menü angezeigt werden
  const registeredClubs = registrations?.filter(
    registration => ( registration.derived_status ?? registration.status ) === myConstants.clubModel.status.registered
  ) ?? [];

  const currentClubName = registeredClubs.find(r => r.club.label === clubLabel)?.club.name ?? clubLabel;

  // Name des Benutzers ermitteln: 
  let userName = 'Loading';
  if (user && !userIsLoading )
    userName = (user.first_name === "")?user.email:user.first_name + " " + user.last_name;
  

  
  // Steuern der Auswahl des Turniers (sofern überhaupt möglich)   
  const [tournamentAnchorElement, setTournamentAnchorElement] = React.useState(null);
  
  // Club Dropdown
  const [clubAnchorElement, setClubAnchorElement] = React.useState(null);
  
  // User Drowndown
  const [userAnchorElement, setUserAnchorElement] = React.useState(null);


  if (tournamentIsLoading||tournamentIsUninitialized||userIsLoading||userIsUninitialized)
  {
    return(
      <AppBar position="fixed">
        <Toolbar>
          <LinearProgress sx={{ flexGrow: 1 }} />
        </Toolbar>
      </AppBar>
    );
  }

    
  // Ausgeben der relevanten Daten, sofern notwendig...
  return(
    <AppBar position="fixed">
      <Toolbar>   

        {
          // Turnier-Selektor
          user?.priviledged ? (
            <FormControl>
              <List component="nav" sx={{ p: 0 }}>
                <ListItemButton 
                  onClick={
                      event => setTournamentAnchorElement(event.currentTarget)
                  } 
                  sx={{ 
                    py: 0, 
                    color: 'inherit' 
                  }}
                >
                  <ListItemText
                    primary={TournamentName(tournaments?.find(t => t.year === yearSelector))}
                    primaryTypographyProps={{ variant: 'body2', color: 'inherit' }}
                  />
                  <KeyboardArrowDownIcon fontSize="small" sx={{ ml: 0.5, opacity: 0.7 }} />
                </ListItemButton>
              </List>
              <Menu 
                anchorEl={tournamentAnchorElement} 
                open={Boolean(tournamentAnchorElement)}
                onClose={() => setTournamentAnchorElement(null)}>
                { 
                  tournaments.map(
                    t => (
                      <MenuItem key={t.year} selected={t.year === yearSelector}
                        onClick={() => { setTournamentAnchorElement(null); navigate('/' + t.year); }}>
                        {t.counter + '. ' + t.name + '  ' + t.year}
                      </MenuItem>
                    )
                  )
                }
              </Menu>
            </FormControl>
          ) : (
            <Typography variant="body2">
              {TournamentName(tournaments?.find(t => t.year === yearSelector))}
            </Typography>
          )
        }


        {
          // Club-Selektor -- nur wenn ein Verein ausgewaehlt ist 
        
          yearSelector && (
            <>
              <Typography sx={{ mx: 1, opacity: 0.5 }}>›</Typography>
              {user?.priviledged ? (
                <FormControl>
                  <List component="nav" sx={{ p: 0 }}>
                    <ListItemButton 
                      onClick={
                        e => setClubAnchorElement(e.currentTarget)
                      } 
                      sx={{ py: 0, color: 'inherit' }}
                    >
                      <ListItemText
                        primary={currentClubName ?? 'Verein wählen...'}
                        primaryTypographyProps={{ variant: 'body2', color: 'inherit' }}
                      />
                      <KeyboardArrowDownIcon fontSize="small" sx={{ ml: 0.5, opacity: 0.7 }} />
                    </ListItemButton>
                  </List>
                  <Menu anchorEl={clubAnchorElement} open={Boolean(clubAnchorElement)}
                    onClose={() => setClubAnchorElement(null)}>
                    {registeredClubs.map(r => (
                      <MenuItem key={r.club.label} selected={r.club.label === clubLabel}
                        onClick={() => { setClubAnchorElement(null); navigate(`/${yearSelector}/${r.club.label}/`); }}>
                        {r.club.name}
                      </MenuItem>
                    ))}
                    
                    <Divider />
                    <MenuItem 
                      onClick={
                        () => { 
                          setClubAnchorElement(null); 
                          navigate(`/${yearSelector}/${myConstants.endpoints.actions.club.add}`); 
                        }
                      }
                    >
                      + Verein anmelden
                    </MenuItem>

                  </Menu>
                </FormControl>
              ) : (
                <Typography variant="body2">{currentClubName}</Typography>
              )}
            </>
          )
        }

        <Box sx={{ flexGrow: 1 }} />

        {/* Benutzername + Menue */}
        <Typography variant="body2" sx={{ mr: 1, display: { xs: 'none', sm: 'block' } }}>
          {userName}
        </Typography>
        {yearSelector && user?.priviledged && (
          <IconButton
            size="large"
            color="inherit"
            onClick={() => navigate(`/${yearSelector}/admin/email`)}
          >
            <InboxIcon />
          </IconButton>
        )}
        <IconButton size="large" onClick={e => setUserAnchorElement(e.currentTarget)} color="inherit">
          <AccountCircle />
        </IconButton>
        <Menu
          anchorEl={userAnchorElement}
          open={Boolean(userAnchorElement)}
          onClose={() => setUserAnchorElement(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem onClick={() => setUserAnchorElement(null)}>Profil</MenuItem>
          <MenuItem onClick={() => setUserAnchorElement(null)}>Konto</MenuItem>
          {user?.priviledged && [
            <MenuItem key="divider" divider />,
            <MenuItem key="admin"
              onClick={() => { setUserAnchorElement(null); navigate(`/${yearSelector}/admin`); }}>
              Administration
            </MenuItem>
          ]}
        </Menu>

      </Toolbar>
    </AppBar>
  );
}